import { DocumentsLinksService } from '@/services/documents-links.service';

export default {
  getDocumentsLinks({ commit }, { params } = {}) {
    return DocumentsLinksService.getList(params).then(response => {
      commit('setDocumentsLinks', response.data.data);

      return response;
    });
  }
};
